import { Component, ReactNode } from 'react';
import { reportError } from '../../error-handling/reportError';
import { Maybe } from '../../types';

interface PreloaderState<T> {
  loading: boolean;
  data: Maybe<T>;
  error: Maybe<unknown>;
}

interface PreloaderProps<T> {
  fetcher: () => Promise<T>;
  render: (state: PreloaderState<T>) => ReactNode;
}

class Preloader<T> extends Component<PreloaderProps<T>, PreloaderState<T>> {
  constructor(props: PreloaderProps<T>) {
    super(props);
    this.state = {
      loading: true,
      data: null,
      error: null
    };
  }

  public async doFetch() {
    try {
      const { fetcher } = this.props;
      const data: T = await fetcher();
      this.setState({
        loading: false,
        data
      });
    } catch (error) {
      console.log('Preloader:', error);
      this.setState({
        loading: false,
        error
      });
      reportError('Preloader.doFetch()', error);
    }
  }

  public componentDidMount() {
    this.doFetch();
  }

  // componentDidUpdate(prevProps: PreloaderProps<T>) {
  //   if (prevProps.fetcher !== this.props.fetcher) {
  //     this.doFetch();
  //   }
  // }

  public render() {
    const { render } = this.props;
    const children = render(this.state);
    return children;
  }
}

export default Preloader;
